<script setup lang="ts">
import { withTrailingSlash } from 'ufo'

const site = useAppConfig().site

const route = useRoute()
const open = ref(false)

const { data: navigation } = await useAsyncData('navigation', () =>
  fetchContentNavigation(),
)

function isActive(path: string) {
  const p = withTrailingSlash(path)
  const current = withTrailingSlash(route.path)
  return current === p || (current.startsWith(p) && p !== '/')
}
</script>

<template>
  <header class="sticky top-0 z-50 bg-white/80 backdrop-blur-sm dark:bg-gray-950/80">
    <div class="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-5 sm:px-6 sm:py-6 lg:px-8">
      <div class="flex min-w-0 flex-1 items-center gap-4 md:min-w-0 md:flex-initial md:gap-8">
        <div class="flex shrink-0 items-center md:hidden">
          <button
            type="button"
            class="rounded-lg p-2 text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-800"
            aria-label="Navigation Menu"
            @click="open = !open"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        <nav class="hidden items-center gap-6 text-lg font-medium md:flex">
          <NuxtLink
            v-for="item in navigation"
            :key="item._path"
            :to="item._path"
            class="transition-colors hover:text-primary-500"
            :class="isActive(item._path) ? 'text-primary-500' : 'text-gray-700 dark:text-gray-300'"
          >
            {{ item.title }}
          </NuxtLink>
        </nav>
      </div>

      <NuxtLink
        to="/"
        class="shrink-0 truncate text-right text-xl font-semibold text-gray-900 dark:text-white md:text-left"
        :aria-label="site.title?.trim() ? undefined : 'Home'"
      >
        {{ site.title || '' }}
      </NuxtLink>
    </div>

    <div
      v-show="open"
      class="bg-white px-4 py-4 space-y-1 dark:bg-gray-950 md:hidden"
    >
      <NuxtLink
        v-for="item in navigation"
        :key="item._path"
        :to="item._path"
        class="block py-2.5 text-lg font-medium"
        :class="isActive(item._path) ? 'text-primary-500' : 'text-gray-700 dark:text-gray-300'"
        @click="open = false"
      >
        {{ item.title }}
      </NuxtLink>
    </div>
  </header>
</template>
